module.exports = __webpack_public_path__ + "img/no-notification.a1bee55e.png";